// Country roadmap for onboarding. Only Latvia is active; the rest are locked
// "invest" targets — clicking one opens the invest chooser (unlock country /
// support the language translation). Campaign keys map to backend CAMPAIGNS.
export const COUNTRIES = [
  { code: 'lv', name: 'Latvija',    flag: '🇱🇻', active: true },
  { code: 'lt', name: 'Lietuva',    flag: '🇱🇹', regionCampaign: 'region_lt', langCampaign: 'lang_lt' },
  { code: 'ee', name: 'Igaunija',   flag: '🇪🇪', regionCampaign: 'region_ee', langCampaign: 'lang_ee' },
  { code: 'fi', name: 'Somija',     flag: '🇫🇮', regionCampaign: 'region_fi', langCampaign: 'lang_fi' },
  { code: 'se', name: 'Zviedrija',  flag: '🇸🇪', regionCampaign: 'region_se', langCampaign: 'lang_se' },
  { code: 'pl', name: 'Polija',     flag: '🇵🇱', regionCampaign: 'region_pl', langCampaign: 'lang_pl' },
  { code: 'de', name: 'Vācija',     flag: '🇩🇪', regionCampaign: 'region_de', langCampaign: 'lang_de' },
];
